import { defineStore } from 'pinia'
import { ping } from '@/services/api/api-status'
import { ref } from 'vue'

export const useApiStatusStore = defineStore('apiStatus', () => {
  const isApiAvailable = ref(true)
  const pingInterval = ref<number | null>(null)

  /**
   * Sets the API availability status
   * @param status - The availability status to set
   */
  function setApiAvailability(status: boolean) {
    isApiAvailable.value = status

    if (!status) {
      startPingInterval()
    } else {
      stopPingInterval()
    }
  }

  /**
   * Starts the ping interval to check API availability every 500ms
   * Only starts a new interval if one isn't already running
   */
  function startPingInterval() {
    if (!pingInterval.value) {
      pingInterval.value = window.setInterval(async () => {
        try {
          const pingResult = await ping()
          setApiAvailability(!pingResult.error)
        } catch (error) {
          // Do nothing
        }
      }, 1000)
    }
  }

  /**
   * Stops the ping interval
   */
  function stopPingInterval() {
    if (pingInterval.value) {
      clearInterval(pingInterval.value)
      pingInterval.value = null
    }
  }

  return {
    isApiAvailable,
    pingInterval,
    setApiAvailability
  }
})
